import React from 'react';
import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const TechnologyStack = ({ technologies }) => {
  return (
    <div className="bg-card rounded-xl p-4 md:p-6 lg:p-8 border border-border">
      <div className="text-center mb-6 md:mb-8 lg:mb-12">
        <motion.h2
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-2xl md:text-3xl lg:text-4xl font-semibold text-foreground mb-3 md:mb-4"
        >
          Technology Stack & Expertise
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.1 }}
          className="text-sm md:text-base lg:text-lg text-muted-foreground"
        >
          Cutting-edge technologies powering innovative solutions
        </motion.p>
      </div>
      <div className="space-y-6 md:space-y-8 lg:space-y-12">
        {technologies?.map((category, catIndex) => (
          <motion.div
            key={catIndex}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: catIndex * 0.1 }}
          >
            <div className="flex items-center gap-3 mb-4 md:mb-6">
              <div className="w-10 h-10 md:w-12 md:h-12 rounded-lg bg-primary/10 flex items-center justify-center">
                <Icon name={category?.icon} size={20} color="var(--color-primary)" />
              </div>
              <h3 className="text-lg md:text-xl lg:text-2xl font-semibold text-foreground">
                {category?.category}
              </h3>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
              {category?.items?.map((tech, techIndex) => (
                <motion.div
                  key={techIndex}
                  initial={{ opacity: 0, scale: 0.8 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  viewport={{ once: true }}
                  transition={{ delay: techIndex * 0.05 }}
                  whileHover={{ scale: 1.05 }}
                  className="bg-muted rounded-lg p-4 md:p-6 flex flex-col items-center justify-center gap-3 cursor-pointer hover:bg-primary/10 transition-all duration-300 border border-transparent hover:border-primary"
                >
                  <div className="w-12 h-12 md:w-16 md:h-16 rounded-lg bg-background flex items-center justify-center">
                    <Image
                      src={tech?.logo}
                      alt={tech?.logoAlt}
                      className="w-8 h-8 md:w-12 md:h-12 object-contain"
                    />
                  </div>
                  <div className="text-center">
                    <p className="text-xs md:text-sm font-medium text-foreground">{tech?.name}</p>
                    <div className="flex items-center justify-center gap-1 mt-1">
                      {[...Array(5)]?.map((_, i) => (
                        <Icon
                          key={i}
                          name="Star"
                          size={10}
                          color={i < tech?.proficiency ? 'var(--color-accent)' : 'var(--color-muted)'}
                          className={i < tech?.proficiency ? 'fill-current' : ''}
                        />
                      ))}
                    </div>
                  </div>
                </motion.div>
              ))}
            </div>
          </motion.div>
        ))}
      </div>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="mt-8 md:mt-12 bg-muted rounded-lg p-4 md:p-6 text-center"
      >
        <div className="flex items-center justify-center gap-2 mb-2">
          <Icon name="Zap" size={20} color="var(--color-primary)" />
          <p className="text-sm md:text-base font-medium text-foreground">
            Constantly evolving with emerging technologies
          </p>
        </div>
        <p className="text-xs md:text-sm text-muted-foreground">
          We stay ahead of the curve to deliver cutting-edge solutions
        </p>
      </motion.div>
    </div>
  );
};

export default TechnologyStack;